interface EntityInterface {
  id: string;
  updateDate: string;
  creationDate: string;
}

export function entityToDTO<T extends EntityInterface>({ updateDate, creationDate, ...dto }: T) {
  return dto;
}
